module.exports = __webpack_public_path__ + "a8bfef032fad2490e091b2105572d0e7.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/12-Betsolutions-Dominoes.png
// module id = 1734
// module chunks = 2